// @flow

import Future from 'fluture'
import {keys, map, values, zipObj} from 'ramda'

// Turn Future rejections into { ...rejectionData, 'future-failure': true} so the whole operation succeeds
// even if one of the calls fails
// https://github.com/fluture-js/Fluture#parallel
//
// Array (Future Error x) -> Array (Future Error future-failure)
// Returning null in middleware by checking future-failure key
// please check handleFuture function in src/store/middleware.js
const stabilize = map(Future.fold((r) => ({...r, 'future-failure': true}), (x) => x))

// {[k]: Future Error x} -> {[k]: ?x}
export const sequenceFuturesObject = (obj: Object) =>
  Future.parallel(100, stabilize(values(obj)))
    .map(zipObj(keys(obj)))



// WEBPACK FOOTER //
// ./src/store/future-helpers.js